import { render } from "./_Etapa2.vue?vue&type=template&id=b1957744&scoped=true"
import script from "./_Etapa2.vue?vue&type=script&lang=ts"
export * from "./_Etapa2.vue?vue&type=script&lang=ts"

import "./_Etapa2.vue?vue&type=style&index=0&id=b1957744&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1957744"

export default script